import { EHChangeCrossCursor, EHGenLine, EventGraphBase, EventGraphNode, EventGraphNodeNotice, EventGraphNodeRender, EventHandlerCalPointerDown, EventHandlerCalPointerMove, EventHandlerCalPrimitiveInView, EventHandlerCalTempLine, EventHandlerCapture, EventHandlerCmdEnd, EventHandlerConfirm, EventHandlerDisableSelect, EventHandlerGeneratePri, EventHandlerGrid, EventHandlerInitCapture, EventHandlerNumberInput, EventHandlerOrthoPolar, EventHandlerSettingOrthoPoint, EventHandlerStart, NeedInputEnum, PythaEventName, UpdateType } from "pytha2";
import { EventHandlerGenAxisLine } from "../event-handler/EHGenAxisLine";
import { EventHandlerGenGridPoint } from "../event-handler/EHGenGridPoint";


/**
 * 绘制轴线
 */
export class EventGraphAxisLine extends EventGraphBase {

    /**
     * axisline指令 生成轴线视图
     */
    static cmd = 'LINE';

    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node4 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "指定下一点",
                inputTypes: [PythaEventName.POINTER_DOWN]
            }]
        });
        const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node8 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node9 = new EventGraphNode(this, EventHandlerConfirm);
        const node10 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node11 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node12 = new EventGraphNode(this, EventHandlerCapture);
        const node14 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node15 = new EventGraphNode(this, EventHandlerCalTempLine);
        const node16 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node17 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "指定第一点",
                option: 'S',
                inputTypes: [PythaEventName.POINTER_DOWN]
            }]
        });
        const node18 = new EventGraphNode(this, EventHandlerCalTempLine);
        const node19 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node21 = new EventGraphNode(this, EventHandlerNumberInput);
        const node22 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "指定下一点",
                option: "N",
                inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
            }]
        });
        const node24 = new EventGraphNode(this, EventHandlerGrid);
        const node25 = new EventGraphNode(this, EventHandlerGrid);
        const node27 = new EventGraphNode(this, EventHandlerGenAxisLine);
        const node28 = new EventGraphNode(this, EHChangeCrossCursor);
        const node29 = new EventGraphNode(this, EventHandlerInitCapture);
        const node32 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node33 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node35 = new EventGraphNode(this, EventHandlerGenGridPoint);
        const node36 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node37 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node38 = new EventGraphNode(this, EventHandlerInitCapture);

        this.addEdge(node9, node10);
        this.addEdge(node11, node12);
        this.addEdge(node14, node15);
        this.addEdge(node3, node4);
        this.addEdge(node1, node2);
        this.addEdge(node22, node21);
        this.addEdge(node22, node5);
        this.addEdge(node21, node18);
        this.addEdge(node15, node24);
        this.addEdge(node24, node16);
        this.addEdge(node25, node8);
        this.addEdge(node27, node22);
        this.addEdge(node2, node28);
        this.addEdge(node1, node29);
        this.addEdge(node32, node27);
        this.addEdge(node5, node33);
        this.addEdge(node33, node18);
        this.addEdge(node4, node32);
        this.addEdge(node29, node11);
        this.addEdge(node1, node9);
        this.addEdge(node28, node17);
        this.addEdge(node17, node3);
        this.addEdge(node12, node14);
        this.addEdge(node27, node14);
        this.addEdge(node35, node36);
        this.addEdge(node8, node27);
        this.addEdge(node18, node35);
        this.addEdge(node36, node37);
        this.addEdge(node37, node38);
        this.addEdge(node38, node25);

        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;

        // https://event.graph.tncet.com/graphs/123

        // const node1 = new EventGraphNode(this, EventHandlerStart);
        // const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        // const node3 = new EventGraphNode(this, EventHandlerCalPointerDown);
        // const node4 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [{
        //         type: NeedInputEnum.ACTIVE,
        //         description: "指定下一点",
        //         inputTypes: [PythaEventName.POINTER_DOWN]
        //     }]
        // });
        // const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        // const node8 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        // const node9 = new EventGraphNode(this, EventHandlerConfirm);
        // const node10 = new EventGraphNode(this, EventHandlerCmdEnd);
        // const node11 = new EventGraphNode(this, EventHandlerCalPointerMove);
        // const node12 = new EventGraphNode(this, EventHandlerCapture);
        // const node14 = new EventGraphNode(this, EventHandlerOrthoPolar);
        // const node15 = new EventGraphNode(this, EventHandlerCalTempLine);
        // const node16 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        // const node17 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [{
        //         type: NeedInputEnum.ACTIVE,
        //         description: "指定第一点",
        //         option: 'S',
        //         inputTypes: [PythaEventName.POINTER_DOWN]
        //     }]
        // });
        // const node18 = new EventGraphNode(this, EventHandlerCalTempLine);
        // const node19 = new EventGraphNode(this, EventHandlerGeneratePri);
        // const node21 = new EventGraphNode(this, EventHandlerNumberInput);
        // const node22 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [{
        //         type: NeedInputEnum.ACTIVE,
        //         description: "指定下一点",
        //         option: "N",
        //         inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
        //     }]
        // });
        // const node24 = new EventGraphNode(this, EventHandlerGrid);
        // const node25 = new EventGraphNode(this, EventHandlerGrid);
        // const node27 = new EventGraphNode(this, EventHandlerGenAxisLine);
        // const node28 = new EventGraphNode(this, EHChangeCrossCursor);
        // const node29 = new EventGraphNode(this, EventHandlerInitCapture);
        // const node32 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        // const node33 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        // const node35 = new EventGraphNode(this, EventHandlerGenGridPoint);
        // const node36 = new EventGraphNode(this, EventHandlerGeneratePri);

        // this.addEdge(node9, node10);
        // this.addEdge(node11, node12);
        // this.addEdge(node14, node15);
        // this.addEdge(node3, node4);
        // this.addEdge(node18, node19);
        // this.addEdge(node1, node2);
        // this.addEdge(node22, node21);
        // this.addEdge(node22, node5);
        // this.addEdge(node21, node18);
        // this.addEdge(node15, node24);
        // this.addEdge(node24, node16);
        // this.addEdge(node25, node8);
        // this.addEdge(node27, node22);
        // this.addEdge(node2, node28);
        // this.addEdge(node1, node29);
        // this.addEdge(node32, node27);
        // this.addEdge(node5, node33);
        // this.addEdge(node33, node18);
        // this.addEdge(node4, node32);
        // this.addEdge(node29, node11);
        // this.addEdge(node1, node9);
        // this.addEdge(node28, node17);
        // this.addEdge(node17, node3);
        // this.addEdge(node12, node14);
        // this.addEdge(node27, node14);
        // this.addEdge(node19, node35);
        // this.addEdge(node35, node36);
        // this.addEdge(node36, node25);
        // this.addEdge(node8, node27);

        // // 指定初始状态下的当前节点和头节点
        // this.currentPointers = [node1];
        // this.head = node1;

        // // https://event.graph.tncet.com/graphs/123

        // const node1 = new EventGraphNode(this, EventHandlerStart);
        // const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        // const node3 = new EventGraphNode(this, EventHandlerCalPointerDown);
        // const node4 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [{
        //         type: NeedInputEnum.ACTIVE,
        //         description: "指定下一点",
        //         inputTypes: [PythaEventName.POINTER_DOWN]
        //     }]
        // });
        // const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        // const node8 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        // const node9 = new EventGraphNode(this, EventHandlerConfirm);
        // const node10 = new EventGraphNode(this, EventHandlerCmdEnd);
        // const node11 = new EventGraphNode(this, EventHandlerCalPointerMove);
        // const node12 = new EventGraphNode(this, EventHandlerCapture);
        // const node14 = new EventGraphNode(this, EventHandlerOrthoPolar);
        // const node15 = new EventGraphNode(this, EventHandlerCalTempLine);
        // const node16 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        // const node17 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [{
        //         type: NeedInputEnum.ACTIVE,
        //         description: "指定第一点",
        //         option: 'S',
        //         inputTypes: [PythaEventName.POINTER_DOWN]
        //     }]
        // });
        // const node18 = new EventGraphNode(this, EventHandlerCalTempLine);
        // const node19 = new EventGraphNode(this, EventHandlerGeneratePri);
        // const node21 = new EventGraphNode(this, EventHandlerNumberInput);
        // const node22 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [{
        //         type: NeedInputEnum.ACTIVE,
        //         description: "指定下一点",
        //         option: "N",
        //         inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
        //     }]
        // });
        // const node24 = new EventGraphNode(this, EventHandlerGrid);
        // const node25 = new EventGraphNode(this, EventHandlerGrid);
        // const node27 = new EventGraphNode(this, EventHandlerGenAxisLine);
        // const node28 = new EventGraphNode(this, EHChangeCrossCursor);
        // const node29 = new EventGraphNode(this, EventHandlerInitCapture);
        // const node31 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        // const node32 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        // const node33 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        // const node34 = new EventGraphNode(this, EventHandlerInitCapture);
        // const node35 = new EventGraphNode(this, EventHandlerGenGridPoint);
        // const node36 = new EventGraphNode(this, EventHandlerGeneratePri);

        // this.addEdge(node9, node10);
        // this.addEdge(node11, node12);
        // this.addEdge(node14, node15);
        // this.addEdge(node3, node4);
        // this.addEdge(node18, node19);
        // this.addEdge(node1, node2);
        // this.addEdge(node22, node21);
        // this.addEdge(node22, node5);
        // this.addEdge(node21, node18);
        // this.addEdge(node15, node24);
        // this.addEdge(node24, node16);
        // this.addEdge(node25, node8);
        // this.addEdge(node27, node22);
        // this.addEdge(node2, node28);
        // this.addEdge(node1, node29);
        // this.addEdge(node32, node27);
        // this.addEdge(node5, node33);
        // this.addEdge(node33, node18);
        // this.addEdge(node4, node32);
        // this.addEdge(node29, node11);
        // this.addEdge(node1, node9);
        // this.addEdge(node28, node17);
        // this.addEdge(node17, node3);
        // this.addEdge(node12, node14);
        // this.addEdge(node27, node14);
        // this.addEdge(node8, node10);
        // this.addEdge(node19, node35);
        // this.addEdge(node35, node36);
        // this.addEdge(node36, node25);

        // // 指定初始状态下的当前节点和头节点
        // this.currentPointers = [node1];
        // this.head = node1;

        // // https://event.graph.tncet.com/graphs/123

        // const node1 = new EventGraphNode(this, EventHandlerStart);
        // const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        // const node3 = new EventGraphNode(this, EventHandlerCalPointerDown);
        // const node4 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [{
        //         type: NeedInputEnum.ACTIVE,
        //         description: "指定下一点",
        //         inputTypes: [PythaEventName.POINTER_DOWN]
        //     }]
        // });
        // const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        // const node8 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        // const node9 = new EventGraphNode(this, EventHandlerConfirm);
        // const node10 = new EventGraphNode(this, EventHandlerCmdEnd);
        // const node11 = new EventGraphNode(this, EventHandlerCalPointerMove);
        // const node12 = new EventGraphNode(this, EventHandlerCapture);
        // const node14 = new EventGraphNode(this, EventHandlerOrthoPolar);
        // const node15 = new EventGraphNode(this, EventHandlerCalTempLine);
        // const node16 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        // const node17 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [{
        //         type: NeedInputEnum.ACTIVE,
        //         description: "指定第一点",
        //         option: 'S',
        //         inputTypes: [PythaEventName.POINTER_DOWN]
        //     }]
        // });
        // const node18 = new EventGraphNode(this, EventHandlerCalTempLine);
        // const node19 = new EventGraphNode(this, EventHandlerGeneratePri);
        // const node21 = new EventGraphNode(this, EventHandlerNumberInput);
        // const node22 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [{
        //         type: NeedInputEnum.ACTIVE,
        //         description: "指定下一点",
        //         option: "N",
        //         inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
        //     }]
        // });
        // const node24 = new EventGraphNode(this, EventHandlerGrid);
        // const node25 = new EventGraphNode(this, EventHandlerGrid);
        // const node27 = new EventGraphNode(this, EventHandlerGenAxisLine);
        // // node27.needExtraFuncOnHandlerActive = (handler) => {
        // //     handler.set("lineType", "AxisLine");
        // // }
        // const node28 = new EventGraphNode(this, EHChangeCrossCursor);
        // const node29 = new EventGraphNode(this, EventHandlerInitCapture);
        // const node31 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        // const node32 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        // const node33 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        // const node34 = new EventGraphNode(this, EventHandlerInitCapture);

        // this.addEdge(node9, node10);
        // this.addEdge(node11, node12);
        // this.addEdge(node14, node15);
        // this.addEdge(node3, node4);
        // this.addEdge(node18, node19);
        // this.addEdge(node1, node2);
        // this.addEdge(node22, node21);
        // this.addEdge(node22, node5);
        // this.addEdge(node21, node18);
        // this.addEdge(node15, node24);
        // this.addEdge(node24, node16);
        // this.addEdge(node25, node8);
        // this.addEdge(node27, node22);
        // this.addEdge(node2, node28);
        // this.addEdge(node1, node29);
        // this.addEdge(node19, node31);
        // this.addEdge(node32, node27);
        // this.addEdge(node5, node33);
        // this.addEdge(node33, node18);
        // this.addEdge(node4, node32);
        // this.addEdge(node29, node11);
        // this.addEdge(node1, node9);
        // this.addEdge(node28, node17);
        // this.addEdge(node17, node3);
        // this.addEdge(node31, node34);
        // this.addEdge(node34, node25);
        // this.addEdge(node12, node14);
        // this.addEdge(node27, node14);
        // this.addEdge(node8, node10);

        // // 指定初始状态下的当前节点和头节点
        // this.currentPointers = [node1];
        // this.head = node1;

        // // https://event.graph.tncet.com/graphs/123
    }
}
